export default "__VITE_ASSET__C8DOZpKb__"